export const requestStatus = {
  SUCCESS: "success",
  FAIL: "failed",
};
